
import { IIpoOffering } from '../../partials/stock-ipo/interfaces/ipo-offerings.interface';
import { StockIpoOfferingAction } from './stock-ipo-offering.action';
// @TODO
// colocar essa classe em um folder de model
/* class IPO {
    id: string;
    active: string;
    activeDescription: string;
    minimumInvestment: number;
    maximumInvestment: number;
    indicativePriceRange?: {
        minimum: number;
        maximum: number;
    };
    initialReservationDate: string;
    closingReservationDate: string;
    guaranteePercentage: number;
    initialNegotiation: string;
    liquidationDate: string;
    closingVinculatedReservationDate: string;
    bookbuilding: string;
    effectiveReservationDate: string;
    prospectFileUrl: string;
    marketNoticeFileUrl: string;
    isLockUp: boolean;
    lockUpDate: String;
} */

export interface IIpoOfferingState {
    ipo_list: IIpoOffering[];
    pending: boolean;
    error: null;
}

export const initialState: IIpoOfferingState = {
    pending: false,
    error: null,
    ipo_list: []
};

export function StockIpoOfferingReducer(state: IIpoOfferingState = initialState, action?: StockIpoOfferingAction) {
    //GET
    switch (action.type) {
        case StockIpoOfferingAction.getAllIpoOfferings:
            return { ...state, pending: true, error: false  };
        case StockIpoOfferingAction.getAllIpoOfferingsSuccess:
            return { ...state, ipo_list: action.payload, pending: false, error: false };
        case StockIpoOfferingAction.getAllIpoOfferingsError:
            return { ...state, pending: false, error: true  };
            
        default:
            return state;
    }
}